import { store } from '@/store/store'
import { BillingStoreState } from '@/modules/billing-module/store/billing-store.model'

export class BillingStoreHelper {
    /// SIDEBAR

    static get sidebarSelectedOption(): BillingStoreState['selectedOption'] {
        return store.getters['billing/selectedOption']
    }
    static set sidebarSelectedOption(payload: BillingStoreState['selectedOption']) {
        store.commit('billing/updateSelectedOption', payload)
    }

    static get sidebarTimeFilter(): BillingStoreState['timeFilter'] {
        return store.getters['billing/timeFilter']
    }
    static set sidebarTimeFilter(payload: BillingStoreState['timeFilter']) {
        store.commit('billing/updateTimeFilter', payload)
    }

    // virtual getters
    static get sidebarSelectedParentOption(): any {
        return store.getters['billing/selectedParentOption']
    }

    // actions
    static async setSelectedOption(payload: BillingStoreState['selectedOption']): Promise<void> {
        await store.dispatch('billing/setSelectedOption', payload)
    }

    static async setTimeFilter(payload: BillingStoreState['timeFilter']): Promise<void> {
        await store.dispatch('billing/setTimeFilter', payload)
    }

    /// GRID

    static get gridType(): BillingStoreState['gridType'] {
        return store.getters['billing/gridType']
    }
    static set gridType(payload: BillingStoreState['gridType']) {
        store.commit('billing/updateGridType', payload)
    }

    static get category(): BillingStoreState['category'] {
        return store.getters['billing/category']
    }
    static set category(payload: BillingStoreState['category']) {
        store.commit('billing/updateCategory', payload)
    }

    static get filterModel(): BillingStoreState['filterModel'] {
        return store.getters['billing/filterModel']
    }
    static set filterModel(payload: BillingStoreState['filterModel']) {
        store.commit('billing/updateFilterModel', payload)
    }

    static get masterSelectedRows(): BillingStoreState['masterSelectedRows'] {
        return store.getters['billing/masterSelectedRows']
    }
    static set masterSelectedRows(payload: BillingStoreState['masterSelectedRows']) {
        store.commit('billing/updateMasterSelectedRows', payload)
    }

    static get detailSelectedRows(): BillingStoreState['detailSelectedRows'] {
        return store.getters['billing/detailSelectedRows']
    }
    static set detailSelectedRows(payload: BillingStoreState['detailSelectedRows']) {
        store.commit('billing/updateDetailSelectedRows', payload)
    }

    // actions
    static async resetGridState(): Promise<void> {
        await store.dispatch('billing/resetGridState')
    }
}
